import { useQuery } from "@tanstack/react-query";
import { api, auth } from "@/lib/api";

export function useMe() {
  return useQuery({
    queryKey: ["me"],
    queryFn: async () => (await api.get("/me")).data,
    enabled: auth.isLoggedIn(),
    staleTime: 60_000,
    retry: 1,
  });
}

export function useBootstrap() {
  return useQuery({
    queryKey: ["bootstrap"],
    queryFn: async () => (await api.get("/bootstrap")).data,
    staleTime: 5 * 60_000,
  });
}
